/* eslint-disable no-param-reassign */
import { put, select, takeLatest } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';

import { messageError } from 'views/ui/toast-message';
import { WARM_UP } from 'utils/constants/stations';
import { setVideo } from './actions';
import { getAllStations, getSelectedStation } from './selectors';

export function* setVideoSaga({ payload: { videoElement } }) {
  try {
    yield put(setVideo.request());

    const { station, group } = yield select(getSelectedStation);
    const stations = yield select(getAllStations);

    let updatedStations = { ...stations };

    if (station === WARM_UP) {
      updatedStations = { ...updatedStations, [WARM_UP]: videoElement };
    } else {
      updatedStations = {
        ...updatedStations,
        [station]: {
          ...updatedStations[station],
          [group]: videoElement,
        },
      };
    }

    yield put(setVideo.success(updatedStations));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(setVideo.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(setVideo.fulfill());
  }
}

export default function* authWatch() {
  yield takeLatest(setVideo.TRIGGER, setVideoSaga);
}
